import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http";
import { Chart } from 'react-google-charts';
import NoData from "../NoData";
import ChartLoader from "../ChartLoader";
import BuketsTableROCFleet from "../BuketsTableROCFleet";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates";
import WaterMark from "../../DashboardMain/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import * as $ from 'jquery';

import { Bar, getElementAtEvent } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata

let res_result

export default function ROC_fleet({ apiend, gloablfilter, type }) {

  const [chartdata, setChartData] = useState([]);
  const [chartdata_new, setChartData_new] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const [toggleFleetBar, setToggleFleetBar] = useState(false);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let barcolor
  const [option_new, SetOption_new] = useState(
    {
      hAxis: {
        gridlines: {
          color: 'transparent'
        },
        title: 'Rate of Charge (%/hr)',
        minValue: 0,
        format: 'short',
        direction: 1,
        slantedText: true,
        slantedTextAngle: 90
      },
      vAxis: {
        gridlines: {
          color: 'transparent'
        },
        title: 'Vehicle Count',
        minValue: 0,
        format: 'short',

      },
      bar: { groupWidth: "100%" },
      legend: "none",
    });

  let modal_title = "";
  if (type === "Slow")
    barcolor = "#348393"
  else
    barcolor = "#FFA650"

  const appyData = (data) => {
    let responce = {
      "<2.5": 0,
      "5": 0,
      "7.5": 0,
      "10": 0,
      "12.5": 0,
      "15": 0,
      "17.5": 0,
      "20": 0,
      ">=20": 0,
    };

    res_result = data;
    if (res_result.length === 0) {
      setChartData((prestate) => []);
    }
    if (res_result.length != 0 || res_result.ROC_percentile.values["50.0"] != null) {
      SetApiResponce(res_result);

      let temp_result = res_result;

      temp_result.map(d => {
        let value = d.ROC_percentile.values["50.0"];

        if (value >= 0 && value < 2.5) {
          responce["<2.5"] = responce["<2.5"] + 1;
        } else if (value >= 2.5 && value < 5) {
          responce["5"] = responce["5"] + 1;
        } else if (value >= 5 && value < 7.5) {
          responce["7.5"] = responce["7.5"] + 1;
        } else if (value >= 7.5 && value < 10) {
          responce["10"] = responce["10"] + 1;
        } else if (value >= 10 && value < 12.5) {
          responce["12.5"] = responce["12.5"] + 1;
        } else if (value >= 12.5 && value < 15) {
          responce["15"] = responce["15"] + 1;
        } else if (value >= 15 && value < 17.5) {
          responce["17.5"] = responce["17.5"] + 1;
        } else if (value >= 17.5 && value < 20) {
          responce["20"] = responce["20"] + 1;
        } else if (value >= 20) {
          responce[">=20"] = responce[">=20"] + 1;
        }
      })

      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);

      loop_keys = ["<2.5", "5", "7.5", "10", "12.5", "15", "17.5", "20", ">=20"]
      let loop_keys_new = ["0-2.5", "2.5-5", "5-7.5", "7.5-10", "10-12.5", "12.5-15", "15-17.5", "17.5-20", ">=20"]

      let colorBar
      (type === 'Fast') ? colorBar = "#FFA650" : colorBar = "#348393"
      loop_keys.map((x, index) => {
        // res_result_final.push([x, responce[x], colorBar]);
        res_result_final.push([x, responce[x], `{stroke-width: 1;stroke-color: black;color:${colorBar}}`]);
      })
      const labels = ["<2.5", "5", "7.5", "10", "12.5", "15", "17.5", "20", ">=20"]

      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Max Battery temp (oC)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },

        ]
      }
      setChartData((prestate) => res_result_final);
      window.dispatchEvent(new Event('resize'));
    } else {
      setChartData((prestate) => []);
      window.dispatchEvent(new Event('resize'));
    }
  }

  let hAxis = {};

  modal_title = "Rate of charging " + type + " chrg";
  hAxis = {
    gridlines: {
      color: 'transparent'
    },
    title: 'Rate of Charge (%/hr)',
    minValue: 0,
    format: 'short',
    direction: 1,
    slantedText: true,
    slantedTextAngle: 90
  };

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Rate of Charge (%/hr)'
        },
        suggestedMin: 0,
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Vehicle Count'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: hAxis,
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
  };


  useEffect(() => {
    if (toggleFleetBar === false) {
      fetchData({ url: API_URL_MAIN + "chargingpage_api/" + apiend, body: { filterdata: gloablfilter, type: type } }, appyData)
    } else {
      fetchData({ url: API_URL_MAIN + "chargingpage_api/" + apiend, body: { filterdata: gloablfilter, type: type } }, appyData)
    }
  }, [gloablfilter, type])


  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" >
          <div className="modal-content">
            <div className="modal-header" >
              <h5 className="modal-title" id="exampleModalLabel">{modal_title}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: "400px" }} >
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length === 0) ? <NoData /> :
                  <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

      <WaterMark />
      {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart chartType="ColumnChart" height={203} data={chartdata} options={options} chartEvents={[
        {
          eventName: 'select',
          callback: ({ chartWrapper }) => {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            if (selection.length === 1) {
              const [selectedItem] = selection;
              const { row } = selectedItem;

              const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
              const count = chartWrapper.getDataTable().Wf[row].c[1].v;
              let filtered_temp = [];
              if (count !== 0) {
                filtered_temp = apiresponce.filter(x => {
                  if (x.ROC_percentile.values["50.0"] < barvalue && x.ROC_percentile.values["50.0"] >= barvalue - 2.5) {
                    return x;
                  }
                  else if (x.ROC_percentile.values["50.0"] > 20 && barvalue === ">=20") {
                    return x
                  }
                  else if (x.ROC_percentile.values["50.0"] < 2.5 && barvalue === "<2.5") {
                    return x
                  }
                })

                function compareObjects(object1, object2, key) {
                  const obj1 = object1.ROC_percentile.values["50.0"]
                  const obj2 = object2.ROC_percentile.values["50.0"]
                  if (obj1 > obj2) {
                    return -1
                  }
                  if (obj1 < obj2) {
                    return 1
                  }
                  return 0
                }

                filtered_temp.sort((value1, value2) => {
                  return compareObjects(value1, value2, 'value')
                })
                SetfilteredData(prestate => filtered_temp);
                window.$('#exampleModal__' + apiend).modal('show');
              }
            }
          }
        }
      ]}
      />)}


      <div className="modal fade" id={apiend + "_modal"} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">{modal_title}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ height: "600px" }}>
              {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart chartType="ColumnChart" data={chartdata} options={options} />)}
            </div>
          </div>
        </div>
      </div>
      {/* model for zoom */}

      {/* model for table */}
      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" style={{ width: "100%" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{modal_title}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  <BuketsTableROCFleet data={filteredData} />
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
      {/* model for table */}
    </>
  );
}
